import React, { useEffect, useState, useRef } from 'react'
import { Button, Form, Spinner, Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../firebase/AuthProvider';
import { ArchiveParticipantResourceAsync, GetAllParticipantResourceAsync } from '../../../services/ParticipantResourceService/ParticipantResouceService';
import { GetAllParticipantResoucesReq, ParticipantResourceDto } from '../../../interfaces/participantResource/participantResource';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import Pagination from '../../ui/Pagination/Pagination';
import { PaginationDto } from '../../../interfaces/Employee/Employee';
import { PAGINATION } from '../../../Data/SD';
import moment from 'moment';
import editicons from '../../../assets/images/editicons.svg';
import trashicons from '../../../assets/images/trashicons.svg';
import { showConfirmationDialog } from '../../modal/ConfimationModal/Confimation';
import { getSortIcon } from '../../../utilities/common/commonFuntion';


const ParticipantResourcePage = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    // data
    const [participantResource, setParticipantResource] = useState<ParticipantResourceDto[]>([]);
    const [participantResourceCount, setParticipantResourceCount] = useState<number>();
    // loader
    const [isLoading, setIsLoading] = useState({
        participantLoading: false,
        deleteParticipant: ""
    });
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: PAGINATION.PageNumber, pageSize: PAGINATION.PageSize });
    const [reload, setReload] = useState<boolean>(true);
    // sorting
    const [sortBy, setSortBy] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

    // search
    const [searchTerm, setSearchTerm] = useState<string>("");
    const searchTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        GetAllResources();
        // eslint-disable-next-line
    }, [pagination, sortBy, sortDirection, searchTerm, reload]);

    const GetAllResources = async () => {
        var token = await currentUser?.getIdToken();
        if (!token) return;

        const paylod: GetAllParticipantResoucesReq = {
            pageNumber: pagination.pageNumber,
            pageSize: pagination.pageSize,
            sortBy: sortBy,
            sortDirection: sortDirection,
            resourceStatus: null,
            searchTearm: searchTerm || null
        }

        try {
            setIsLoading(prev => ({ ...prev, participantLoading: true }));
            var res = await GetAllParticipantResourceAsync(token, paylod);
            if (res.success) {
                setParticipantResourceCount(res.data.totalCount);
                setParticipantResource(res.data.items);
            } else {
                toast.error(res.message);
            }
        } catch (error: any) {
            toast.error(error instanceof AxiosError ? error.response?.data.message : error.message || "Error to saving the Resource");
        } finally { setIsLoading(prev => ({ ...prev, participantLoading: false })); }
    };

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }

    // Sorting handler
    const handleSort = (field: string) => {
        if (sortBy === field) {
            setSortDirection(prev => prev === "asc" ? "desc" : "asc");
        } else {
            setSortBy(field);
            setSortDirection("asc");
        }
    };

    // Debounced search handler
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            setSearchTerm(value);
            setPagination(prev => ({ ...prev, pageNumber: 1 })); // Reset to first page on search
        }, 500);
    };

    const ArchiveParticipantResource = async (resourceId: string) => {
        const token = await currentUser?.getIdToken();
        const isConfirm = await showConfirmationDialog();
        if (!token || !isConfirm) return;

        try {
            setIsLoading(prev => ({ ...prev, deleteParticipant: resourceId }));
            const res = await ArchiveParticipantResourceAsync(token, resourceId);
            if (res.success) {
                toast.success(res.message);
                setReload(!reload);
            } else {
                toast.error(res.message)
            }
        } catch (error: any) {
            toast.error(error instanceof AxiosError ? error.response?.data.message : error.message || "Error to Delete the Resource");
        } finally { setIsLoading(prev => ({ ...prev, deleteParticipant: "" })); }


    }

    return (
        <div className='common_card'>
            <div className="top top_bar_flx" >
                <div className="top_bar_tittle">
                    <h2>Participants Resources</h2>
                </div>
                <div className="top_right_flx">
                    {/* Search bar with debounce */}
                    <Form className="d-flex align-items-center me-2" onSubmit={e => e.preventDefault()}>
                        <Form.Control
                            size="sm"
                            type="text"
                            placeholder="Search..."
                            style={{ minWidth: 220 }}
                            className="me-2 py-0"
                            onChange={handleSearchChange}
                        />
                    </Form>
                    <Button
                        variant="primary"
                        className="btn_sm"
                        onClick={() =>
                            navigate(
                                "/dashboard/owner/resources/Add"
                            )
                        }
                    >
                        Add New Resource
                    </Button>
                </div>
            </div >

            <Table className="common_table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort("title")} style={{ cursor: "pointer" }}>
                            Title {getSortIcon(sortBy === "title", sortDirection)}
                        </th>
                        <th>Description</th>
                        <th>Phone</th>
                        <th onClick={() => handleSort("city")} style={{ cursor: "pointer" }}>
                            City {getSortIcon(sortBy === "city", sortDirection)}
                        </th>
                        <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                            Status {getSortIcon(sortBy === "status", sortDirection)}
                        </th>
                        <th onClick={() => handleSort("createddate")} style={{ cursor: "pointer" }}>
                            Created Date {getSortIcon(sortBy === "createddate", sortDirection)}
                        </th>
                        <th>Created By</th>
                        <th>Modified By</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        isLoading.participantLoading
                            ? <tr><td colSpan={8} className='text-center'><Spinner size='sm' /> Loading...</td></tr>
                            : participantResource.length == 0
                                ? <tr><td colSpan={8} className='text-center'>No Data Found</td></tr>
                                : (participantResource.map((resource) => (
                                    <tr key={resource.id}>
                                        <td className='shortDescription' title={resource.title}>{resource.title}</td>
                                        <td className='shortDescription' title={resource.description}>{resource.description}</td>
                                        <td>{resource.phoneNumber}</td>
                                        <td>{resource.city}</td>
                                        <td>{resource.status}</td>
                                        <td>{moment(resource.createdAt).local().format("MM/DD/YYYY")}</td>
                                        <td>{resource.createdByAuther?.autherName}</td>
                                        <td>{resource.modifiedByAuther?.autherName}</td>
                                        <td onClick={(e) => e.stopPropagation()}>
                                            <div className="action_btn">
                                                <span>
                                                    <img src={editicons} alt="editicons" onClick={() => navigate(`/dashboard/owner/resources/Edit/${resource.id}`)} />
                                                </span>
                                                <span>
                                                    {isLoading.deleteParticipant == resource.id ? <Spinner size='sm' /> : <img src={trashicons} alt="trashicons" onClick={() => ArchiveParticipantResource(resource.id)} />}

                                                </span>

                                            </div>
                                        </td>
                                    </tr>
                                )))
                    }
                </tbody>
            </Table>

            {(participantResourceCount && participantResourceCount > 0) ? (
                <Pagination
                    currentPage={pagination.pageNumber}
                    totalPages={Math.ceil(participantResourceCount / pagination.pageSize)}
                    onPageChange={onPageChange}
                    pageSize={pagination.pageSize}
                    resetPageSize={resetPageSize}
                />
            ) : <></>}

        </div >
    )
}

export default ParticipantResourcePage